import React from 'react';

import styles from './styles.module.scss';

const NoMoreTrips: React.FunctionComponent = () => {
  return <li className={styles['no-more-trips']}>No more trips found</li>;
};

export default React.memo(NoMoreTrips);
